/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormOption
 */
export interface FormOption {
    /**
     * 
     */
    option: string;
    /**
     * 
     */
    label: string;
}

/**
 * Check if a given object implements the FormOption interface.
 */
export function instanceOfFormOption(value: object): value is FormOption {
    if (!('option' in value) || value['option'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function FormOptionFromJSON(json: any): FormOption {
    return FormOptionFromJSONTyped(json, false);
}

export function FormOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormOption {
    if (json == null) {
        return json;
    }
    return {
        
        'option': json['option'],
        'label': json['label'],
    };
}

export function FormOptionToJSON(json: any): FormOption {
    return FormOptionToJSONTyped(json, false);
}

export function FormOptionToJSONTyped(value?: FormOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'option': value['option'],
        'label': value['label'],
    };
}

